import { v4 as uuidv4 } from "uuid";
export class RoleModel {
    constructor() {
        this.id = uuidv4();
        this.name = "";
    }
}
export class RolePageElementModel {
    constructor() {
        this.id = uuidv4();
        this.pageId = uuidv4();
        this.pageElementId = uuidv4();
    }
}
export class Role extends RoleModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
export class RolePageElement extends RolePageElementModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
